
const initSecondaryHeader = () => {
  const primaryMainLinks = document.querySelectorAll('.header__secondary-menu .main-link');
  
  if (primaryMainLinks) {
    primaryMainLinks.forEach((mainLink) => {
      mainLink.addEventListener('click', (e) => {
        const mainCount = mainLink.getAttribute('data-main');
        
        document.querySelectorAll(`.header__secondary-menu .main-link[data-main="${mainCount}"]`).forEach((main) => {
          if (main.classList.contains('active')) {
            main.classList.remove('active');
          }
        });

        document.querySelectorAll(`.header__secondary-menu .secondary-submenu[data-main="${mainCount}"]`).forEach((secondarySubmenu) => {
          if (secondarySubmenu.classList.contains('active')) {
            secondarySubmenu.classList.remove('active');
          }
        });

        document.querySelectorAll(`.header__secondary-menu .additional-menu[data-main="${mainCount}"]`).forEach((additionalMenu) => {
          if (additionalMenu.classList.contains('active')) {
            additionalMenu.classList.remove('active');
          }
        });

        const linkID = mainLink.getAttribute('data-id');
        mainLink.classList.add('active');

        if (document.querySelector(`.header__secondary-menu .secondary-submenu[data-id="${linkID}"]`)) {
          const subMenus = document.querySelectorAll(`.header__secondary-menu .secondary-submenu[data-id="${linkID}"]`);

          subMenus.forEach((subMenu) => {
            subMenu.classList.add('active');
          });
        }

        if (document.querySelector(`.header__secondary-menu .additional-menu[data-id="${linkID}"]`)) {
          const additionalSubMenus = document.querySelectorAll(`.additional-menu[data-id="${linkID}"]`);

          additionalSubMenus.forEach((additionalSubMenu) => {
            additionalSubMenu.classList.add('active');
          });
        }
      });
    });
  }
};

export default initSecondaryHeader;
